
//==================BEGIN DEPENDENCIES========================

import 'reflect-metadata';
  
import 'jquery';
  
import 'stickyfilljs';
  

//==================BEGIN UTILITY========================

import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/embo/node_modules/ui-core/utility/js/namespace';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/embo/utility/js/utils';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/embo/node_modules/ui-core/utility/js/tests';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/embo/node_modules/ui-core/utility/js/observe-dom';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/embo/node_modules/ui-core/utility/ab-logger/js/ab-logger';
  

//==================BEGIN PLUGINS========================

import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/embo/node_modules/ui-core/plugins/polyfills/js/Promise/es6-promise.min';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/embo/node_modules/ui-core/plugins/polyfills/js/Promise/es6-promise.auto.min';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/embo/node_modules/ui-core/plugins/panzoom/jquery.panzoom';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/embo/node_modules/ui-core/plugins/controller/js/controller';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/embo/node_modules/ui-core/plugins/enquireJs/js/enquire';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/embo/node_modules/ui-core/plugins/controller/js/enquireIt';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/embo/node_modules/ui-core/plugins/truncate/js/truncate';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/embo/node_modules/ui-core/plugins/magicSearch/js/magicsuggest';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/embo/node_modules/ui-core/plugins/transplant/js/transplant';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/embo/node_modules/ui-core/plugins/dotdotdot/js/dotdotdot';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/embo/node_modules/ui-core/plugins/simplebar/js/simplebar';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/embo/node_modules/ui-core/plugins/pagination/js/client-pagination';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/embo/node_modules/ui-core/plugins/sortable-table/js/sortable-table';
  

//==================BEGIN VARIABLES========================

import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/embo/variables/js/embo-grid-variables';
  

//==================BEGIN BASIC========================

import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/embo/node_modules/ui-core/basic/lists/js/list';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/embo/node_modules/ui-core/basic/inputs/js/inputs';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/embo/basic/base/js/base';
  

//==================BEGIN COMPONENTS========================

import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/embo/components/tooltip/js/tooltip';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/embo/components/popover/js/popover';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/embo/components/raa/templates/email/js/email';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/embo/components/pagination/js/client-pagination';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/embo/components/embo-press-journals/js/embo-press-journals';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/embo/components/embo-press-features/js/embo-press-features';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/embo/components/traning-courses/js/traning-courses';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/embo/components/issue-item/js/issue-item';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/embo/components/sections-navbar/js/sections-navbar';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/embo/components/header/js/header';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/embo/node_modules/ui-core/components/modal/js/modal';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/embo/components/figure-viewer/js/figure-viewer-script';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/embo/components/teaser/js/teaser';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/embo/node_modules/ui-core/components/article-actions-bar/js/article-action-bar';
  

//==================BEGIN WIDGETS========================

import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/embo/widgets/search-history/js/search-history';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/embo/widgets/access-denial/js/access-denial';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/embo/widgets/slot-license-usage/js/slot-license-usage';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/embo/widgets/download-citations/js/download-citations';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/embo/widgets/ip-ranges/js/ip-ranges';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/embo/widgets/manage-article-select/js/manage-article-select';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/embo/node_modules/ui-core/widgets/cookie-policy-popup/js/cookie-policy-popup';
  
import ShowRecommendedPopup from '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/embo/widgets/show-recommended/js/show-recommended-popup';  

//==================BEGIN TEMPLATES========================

import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/embo/templates/advanced-search/js/advanced-search-page';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/embo/node_modules/ui-core/templates/footer/js/footer';
  

//==================BEGIN GROUPS========================

import './groups/_jcf';

import './groups/_jquery';

import tabsMain from './groups/_tabs';
const main = (UX) => {
    const $transplant = Array.prototype.slice.call(document.querySelectorAll('[data-toggle="transplant"]')),
        $sortableTable = Array.prototype.slice.call(document.getElementsByClassName('table--sortable')),
        $list = Array.prototype.slice.call(document.getElementsByClassName('expandable-list')),
        $tooltip = Array.prototype.slice.call(document.getElementsByClassName('tooltip')),
        $popover = Array.prototype.slice.call(document.getElementsByClassName('popover')),
        $email = document.getElementById('fakeEmail'),
        $pager = Array.prototype.slice.call(document.getElementsByClassName('js-pager')),
        $ePressJournals = Array.prototype.slice.call(document.getElementsByClassName('epress-journals')),
        $emboPressfeatures = Array.prototype.slice.call(document.getElementsByClassName('embo-press-features')),
        $trainingCourses = Array.prototype.slice.call(document.getElementsByClassName('training-courses')),
        $issueItem = Array.prototype.slice.call(document.getElementsByClassName('issue-item__authors')),
        $sidebarSections = Array.prototype.slice.call(document.getElementsByClassName('sections-block')),
        $header = Array.prototype.slice.call(document.getElementsByClassName('header')),
        $modal = Array.prototype.slice.call(document.querySelectorAll('.modal, [data-toggle="modal"]')),
        $figureViewer = Array.prototype.slice.call(document.querySelectorAll('.figure:not(.holder),.colored-block,.component-container')),
        $teaser = Array.prototype.slice.call(document.querySelectorAll('.teaser, .teaser__item__authors')),
        $articleActionsbar = Array.prototype.slice.call(document.getElementsByClassName('article-actionbar')),
        $searchHistory = Array.prototype.slice.call(document.getElementsByClassName('search-history')),
        $accessDenial = Array.prototype.slice.call(document.getElementsByClassName('slotLicenseConsumption')),
        $slotLicense = Array.prototype.slice.call(document.getElementsByClassName('slot-license-usage')),
        $ipRanges = Array.prototype.slice.call(document.getElementsByClassName('ip-ranges')),
        $manageArticleSelect = Array.prototype.slice.call(document.getElementsByClassName('js__removeUsers')),
        $cookiePolicyPopupWidget = Array.prototype.slice.call(document.getElementsByClassName('cookiePolicy-popup')),
        $showRecommendedTest = Array.prototype.slice.call(document.querySelectorAll('.show-recommeneded-popup, .show-recommended-placeholder'))

try {
        UX.controller.init();
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($transplant.length ) {
            UX.transplant.init($transplant);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($sortableTable.length ) {
            UX.sortableTable.init($sortableTable);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($list.length ) {
            UX.list.init($list);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        UX.fieldsCtrl.init();
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($tooltip.length ) {
            UX.tooltip.init($tooltip);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($popover.length ) {
            UX.popover.init($popover);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($email ) {
            UX.email.init($email);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($pager.length ) {
            UX.pager.init($pager);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($ePressJournals.length ) {
            UX.ePressJournals.init($ePressJournals);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($emboPressfeatures.length ) {
            UX.emboPressfeatures.init($emboPressfeatures);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($trainingCourses.length ) {
            UX.trainingCourses.init($trainingCourses);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($issueItem.length ) {
            UX.issueItem.init($issueItem);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($sidebarSections.length ) {
            UX.sidebarSections.init($sidebarSections);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($header.length ) {
            UX.header.init($header);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($modal.length ) {
            UX.modal.init($modal);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($figureViewer.length ) {
            UX.figureViewer.init($figureViewer);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($teaser.length ) {
            UX.teaser.init($teaser);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($articleActionsbar.length ) {
            UX.articleActionsbar.init($articleActionsbar);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($searchHistory.length ) {
            UX.searchHistory.init($searchHistory);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($accessDenial.length ) {
            UX.accessDenial.init($accessDenial);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($slotLicense.length ) {
            UX.slotLicense.init($slotLicense);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($ipRanges.length ) {
            UX.ipRanges.init($ipRanges);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($manageArticleSelect.length ) {
            UX.manageArticleSelect.init($manageArticleSelect);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($cookiePolicyPopupWidget.length ) {
            UX.cookiePolicyPopupWidget.init($cookiePolicyPopupWidget);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($showRecommendedTest.length ) {
            UX.showRecommendedTest = $showRecommendedTest
                .map(item=>new ShowRecommendedPopup(item).initialize())
        }
    } catch (err) {
        console.error(err);
    }
    
tabsMain(UX);

}
import './webpack-public-path'
const importPromises = async () => {

    
    const { default: dynamicMain } = await import(/* webpackChunkName: 'dynamic-imports' */ './dynamic-imports');
    const promises = Object.values(await dynamicMain(UX));
    

    
    promises.push(await import(/* webpackChunkName: 'requestidlecallback-polyfill' */ 'requestidlecallback-polyfill'));
    let lazyPromise = new Promise(resolve => {
        window.requestIdleCallback(
            async () => {
                const { default: lazyMain } = await import(/* webpackChunkName: 'lazy-imports' */ './lazy-imports');
                await lazyMain(UX);
                resolve();
            },
            { timeout: 5000 }
        );
    });
    

    promises.push(lazyPromise);

    return Promise.all(promises);
};

const build = async (UX) => {
    
    const isIE = navigator.userAgent.indexOf('MSIE') !== -1
        || navigator.appVersion.indexOf('Trident/') > -1;
    if (isIE) {
        await import(/* webpackChunkName: 'ie-imports' */ './groups/_ie');
    }
    

    main(UX);
    await importPromises();
    try {
        UX.abLogger.init();
    } catch (err) {
        console.error(err);
    }
    
try {
        UX.enquireIt.init();
    } catch (err) {
        console.error(err);
    }
    
};

build(UX).then(() => {
    console.debug('JS LOADED');
});

